/* @flow weak */
import AffiliationStore from 'stores/AffiliationStore';
import FeatureStore from 'stores/FeatureStore';
import OrganizationStore from 'stores/OrganizationStore';

export default function shouldEnableCsvUploadForGroup(group) {
  if (FeatureStore.hasFeature('disable_csv_upload')) {
    return false;
  }

  if (!group.isStaffClass()) {
    return false;
  }

  const org = OrganizationStore.getOrganization(group.getStaffClassOrgId());
  const affiliation = AffiliationStore.getAffiliation(org.id);
  return affiliation.roles.includes('teacher') || affiliation.roles.includes('admin');
}



// WEBPACK FOOTER //
// ./src/utils/shouldEnableCsvUploadForGroup.js